import { render, staticRenderFns } from "./Disparos.vue?vue&type=template&id=5e5a6fd8"
import script from "./Disparos.vue?vue&type=script&lang=js"
export * from "./Disparos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports